import React from 'react';
import { Flex, Text } from '@smarterservices/smarter-ui';
import {
  usePlayerStore,
  useAppStore,
  getStore,
} from '../../../stores/StoreContext';
import { RoomContext } from '@livekit/components-react';

const ComputerInfo = () => {
  const AppStore = getStore('appStore');

  return (
    <Flex>
      <Flex.Item
        as="div"
        width="35%"
        align="start"
        padding="none small none none"
      >
        <Text>Computer Info</Text>
      </Flex.Item>
      <Flex.Item as="div" shouldGrow width="65%" align="start">
        <Text>Computer Info</Text>
      </Flex.Item>
    </Flex>
  );
};

export default ComputerInfo;
